import { render } from "./CatalogoConFiltroClienti.vue?vue&type=template&id=a34887b6&scoped=true"
import script from "./CatalogoConFiltroClienti.vue?vue&type=script&lang=js"
export * from "./CatalogoConFiltroClienti.vue?vue&type=script&lang=js"

import "./CatalogoConFiltroClienti.vue?vue&type=style&index=0&id=a34887b6&scoped=true&lang=scss"

import exportComponent from "D:\\Usuario\\Desktop\\code\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a34887b6"]])

export default __exports__